export default {
  common: {
    login: "Login",
    userName: "User name",
    password: "Password",
    rememberPassword: "Remember",
    modifyPassword: "Modify password",
    accountRegister: "Account register",
    pleaseInput: "Please input",
    loginErrorCheckNamePassword: "Login failed, please check username and password",
    guest: "Guest",
    superAdmin: "Super Admin",
    logOut: "Log out",
    inputUserName: "Input User Name",
    inputPassword: "Input Password",
    modifySuccessfully: "Modify password successfully!",

    using: "Using",
    toLogin: "to login",
    noOktaLoginUrl: "No OKTA login url",
    uncheckSwitch: "Uncheck this box to switch to regular login mode",

    noADLoginUrl: "No Azure AD login url"
  },
  register: {
    email: "E-mail address",
    confirmPassword: "Confirm password",
    register: "Register",
    emailRequire: "Email is require",
    passwordRequire: "Password is require",
    confirmPasswordRequire: "Confirm password is require",
    passwordInconsistency: "Password inconsistency",
    registeredSuccessfully: "Registered successfully!",
    jumpToLoginPage: "System will automatically redirect you to the login page.",
    contactAdminActivate: "Please contact the administrator to activate account before you login.",
    USER_EXISTS: "This user already exists",

    emailExists: "E-mail already exists",

    emailInconsistency: "Email inconsistency",
    confirmEmailAddress: "Confirm Email address",
    emailAgain: "Enter E-mail again",

    approvedCarrierOnly: "Strictly for Approved Carrier Employees Only."
  },
  my: {
    about: "About",
    language: "Language",
    nomenclatureList: "Nomenclature list",

    appName: "App name",
    version: "Version",
    iecmFF: "iECM Functionality Framework",
    paragraph1:
      "1. The baseline estimation methods are fully compliant with the International Performance Measurement and Verification Protocol (IPMVP) and each method aligns with IPMVP guidelines to ensure credible and transparent energy performance evaluation.",
    paragraph2: "2. The current library use performance curves based on AHRI conditions.",
    paragraph3: "3. Inputs of AHRI certified e-CAT performance for a post retrofit chiller is allowed.",

    learningCenter: "Learning center",
    learningCenterDescription: "Access tutorial videos, user manuals, and workflow guidance to help you use iECM more effectively."
  }
}



// WEBPACK FOOTER //
// ./src/locale/login/en.js